import * as z from "zod/v4";

export const createWorkOrderViewFolder = {
  name: "createWorkOrderViewFolder" as const,
  input: z.object({ name: z.string() }),
  output: z.object({ folderId: z.string() }),
};
